import simplify from 'vis-why'

/**
 * Get a sample from a data array
 *
 * @param {Array} data - the array to obtain sample from. Contains objects with the keys date and value
 * @param {*} limit - the number of points that will remain
 */
export function getSample(data, limit) {
  if (data.length <= limit) {
    return data
  } else {
    return simplify(
      data.map(({ value, date }) => [date, value]),
      limit
    ).map(([date, value]) => ({
      date,
      value,
    }))
  }
}

/**
 *
 * @param {Array} data - The array to split.
 * @param {Array} zoom - an array containing the minimum and maximum dates of the zoom to split
 * @return {Array} Array of 3 inner data arrays (before zoom, in zoom and after zoom).
 */
export const splitOnZoom = (data, zoom) =>
  data.reduce(
    (acc, curr) => {
      if (curr.date < zoom[0]) {
        acc[0].push(curr)
      } else if (curr.date > zoom[1]) {
        acc[2].push(curr)
      } else {
        acc[1].push(curr)
      }
      return acc
    },
    [[], [], []]
  )

/**
 * Flatten and sort an array of time series
 * Inserts a "fake" measurement with null value between each time serie
 *
 * @param {*} series
 * @return {Array<{date: Date, value: Number}>}
 */
export function flattenTimeSeries(series) {
  return series
    .reduce(
      (acc, { data = [] }) =>
        data.length ? [...acc, { value: null, date: new Date(data[0].date.getTime() - 1) }, ...data] : acc,
      []
    )
    .slice(1) // omit first element
    .sort((a, b) => a.date - b.date)
}
